
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 5c4.136 0 7.5 3.364 7.5 7.5 0 2.59-2.365 4.947-2.466 5.047L16 29.081 4.46 17.541C4.365 17.447 2 15.09 2 12.5 2 8.364 5.364 5 9.5 5c2.892 0 5.327 1.804 6.5 2.854C17.173 6.804 19.608 5 22.5 5z"}})])
          )
        }
      }
    